import React, { useEffect, useState } from "react";

import { Controller, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";

import ModalIndex from "@Modals/layout/index";
import FormTextarea from "@components/formGroup/formTextarea";
import { useNotification } from "@hooks/useNotification";
import { IndividualObjective } from "@services/all.services";

/**
 * @param {Object} props
 * @param {boolean} props.isOpen
 * @param {() => void} props.onCloseModal
 * @param {string} props.initialEmployeeNote
 * @param {string} props.individualObjectiveId
 * @param {(note: string) => void=} props.onSuccess
 * @returns
 */
export default function ModalEditEmployeeNote(props) {
  const {
    isOpen,
    onCloseModal,
    initialEmployeeNote = "",
    individualObjectiveId,
    onSuccess = () => {},
  } = props;

  const { t } = useTranslation("assesment.frequency");
  const { showError, showSuccess } = useNotification();
  const { control, handleSubmit, reset } = useForm({
    defaultValues: {
      employeeNote: "",
    },
  });
  const [isSaving, setIsSaving] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setIsSaving(false);
      reset({
        employeeNote: initialEmployeeNote || "",
      });
    }
  }, [isOpen, initialEmployeeNote, reset]);

  async function handleSuccess(formValue) {
    const nextEmployeeNote = (formValue.employeeNote || "").trim();

    try {
      setIsSaving(true);
      await IndividualObjective.updateById({
        _id: individualObjectiveId,
        employeeNote: nextEmployeeNote,
      });
      showSuccess("update_action_success", { object: "note" });
      onSuccess(nextEmployeeNote);
      onCloseModal();
    } catch (error) {
      console.error(error);
      showError("error");
    } finally {
      setIsSaving(false);
    }
  }

  function handleError() {}

  return (
    <ModalIndex
      isOpen={isOpen}
      onClickClose={onCloseModal}
      isLoading={isSaving}
      buttonType="double"
      buttonOptions={{
        click: handleSubmit(handleSuccess, handleError),
        color: "green",
        title: t("Enregistrer"),
      }}
      buttonCancelOptions={{
        click: onCloseModal,
        color: "outlined",
        title: t("Annuler"),
      }}
      widthType="medium"
      title={t("Notes employé")}
      positionTitle="!arh-text-center !arh-pl-0"
      parentDoubleBtn="!arh-justify-center"
      WithMarge="!arh-p-10"
    >
      <div className="arh-mx-auto arh-w-full arh-max-w-[24.25rem]">
        <Controller
          control={control}
          name="employeeNote"
          render={({ field: { onChange, value, name } }) => (
            <FormTextarea
              label={t("Notes employé")}
              placeholder={t("Notes employé")}
              value={value}
              onChange={onChange}
              name={name}
              ParentForm="arh-mb-0 arh-w-full"
              classLabel="!arh-mb-2"
              classTextarea="arh-h-[6.125rem] !arh-px-4 !arh-py-3"
            />
          )}
        />
      </div>
    </ModalIndex>
  );
}
